import { getZ3PConfigValue } from './helper';

const carMakes = [
  'Acura',
  'Audi',
  'BMW',
  'Buick',
  'Cadillac',
  'Chevrolet',
  'Chrysler',
  'DMC',
  'Dodge',
  'Fiat',
  'Ford',
  'GMC',
  'Honda',
  'Hummer',
  'Hyundai',
  'Infiniti',
  'Isuzu',
  'Jaguar',
  'Jeep',
  'Kia',
  'Land Rover',
  'Lexus',
  'Lincoln',
  'Mazda',
  'Mercedes-Benz',
  'Mercury',
  'Mini',
  'Mitsubishi',
  'Mobility Ventures',
  'Nissan',
  'Oldsmobile',
  'Plymouth',
  'Pontiac',
  'Porsche',
  'Ram',
  'Saab',
  'Saturn',
  'Scion',
  'Smart',
  'Subaru',
  'Suzuki',
  'Tesla',
  'Toyota',
  'Volkswagen',
  'Volvo',
];

export const carMakeOptions = carMakes.map((m) => ({ id: m, name: m }));

export const commonVehicleColors = [
  { id: 'Black', name: 'Black' },
  { id: 'Blue', name: 'Blue' },
  { id: 'Brown', name: 'Brown' },
  { id: 'Gold', name: 'Gold' },
  { id: 'Gray', name: 'Gray' },
  { id: 'Green', name: 'Green' },
  { id: 'Orange', name: 'Orange' },
  { id: 'Purple', name: 'Purple' },
  { id: 'Red', name: 'Red' },
  { id: 'Silver', name: 'Silver' },
  { id: 'White', name: 'White' },
  { id: 'Yellow', name: 'Yellow' },
  { id: 'Other', name: 'Other' },
];

export const heavyDutyMakes = [
  { id: 'Chevrolet', name: 'Chevrolet' },
  { id: 'Ford', name: 'Ford' },
  { id: 'Freightliner', name: 'Freightliner' },
  { id: 'Hino', name: 'Hino' },
  { id: 'International Trucks', name: 'International Trucks' },
  { id: 'Isuzu', name: 'Isuzu' },
  { id: 'Kenworth Truck Company', name: 'Kenworth Truck Company' },
  { id: 'Mack', name: 'Mack' },
  { id: 'Peterbilt', name: 'Peterbilt' },
  { id: 'Ram', name: 'Ram' },
  { id: 'Volvo', name: 'Volvo' },
  { id: 'Western Star Trucks', name: 'Western Star Trucks' },
  { id: 'Other', name: 'Other' },
];

export const heavyDutyModels = [
  { id: '220', name: '220' },
  { id: '238', name: '238' },
  { id: '268', name: '268' },
  { id: '325', name: '325' },
  { id: '330', name: '330' },
  { id: '338', name: '338' },
  { id: '365', name: '365' },
  { id: '367', name: '367' },
  { id: '389', name: '389' },
  { id: '520', name: '520' },
  { id: '535', name: '535' },
  { id: '536', name: '536' },
  { id: '537', name: '537' },
  { id: '548', name: '548' },
  { id: '567', name: '567' },
  { id: '579', name: '579' },
  { id: '3500', name: '3500' },
  { id: '4500', name: '4500' },
  { id: '4700', name: '4700' },
  { id: '4800', name: '4800' },
  { id: '4900', name: '4900' },
  { id: '5500', name: '5500' },
  { id: '5700', name: '5700' },
  { id: '6900', name: '6900' },
  { id: '114SD Natural Gas', name: '114SD Natural Gas' },
  { id: '122SD', name: '122SD' },
  { id: '220 EV', name: '220 EV' },
  { id: '258ALP', name: '258ALP' },
  { id: '258LP', name: '258LP' },
  { id: '268A', name: '268A' },
  { id: '49X', name: '49X' },
  { id: '520 EV', name: '520 EV' },
  { id: '5700XE', name: '5700XE' },
  { id: '579 EV', name: '579 EV' },
  { id: 'C500', name: 'C500' },
  { id: 'Cascadia', name: 'Cascadia' },
  { id: 'Cascadia Natural Gas', name: 'Cascadia Natural Gas' },
  { id: 'CV Series', name: 'CV Series' },
  { id: 'DuraStar', name: 'DuraStar' },
  { id: 'eCascadia', name: 'eCascadia' },
  { id: 'eM2', name: 'eM2' },
  { id: 'F-550', name: 'F-550' },
  { id: 'F-560', name: 'F-560' },
  { id: 'F-750', name: 'F-750' },
  { id: 'FTR', name: 'FTR' },
  { id: 'Granite', name: 'Granite' },
  { id: 'HV Series', name: 'HV Series' },
  { id: 'HX Series', name: 'HX Series' },
  { id: 'K270/K370', name: 'K270/K370' },
  { id: 'K270E/K370E', name: 'K270E/K370E' },
  { id: 'L6', name: 'L6' },
  { id: 'L7', name: 'L7' },
  { id: 'Lonestar', name: 'Lonestar' },
  { id: 'LR', name: 'LR' },
  { id: 'LT Series', name: 'LT Series' },
  { id: 'M2 106', name: 'M2 106' },
  { id: 'M2 112', name: 'M2 112' },
  { id: 'M2 112 Natural Gas', name: 'M2 112 Natural Gas' },
  { id: 'M4', name: 'M4' },
  { id: 'M5', name: 'M5' },
  { id: 'Mack Anthem', name: 'Mack Anthem' },
  { id: 'MD Series', name: 'MD Series' },
  { id: 'MV Series', name: 'MV Series' },
  { id: 'NPR', name: 'NPR' },
  { id: 'NQR', name: 'NQR' },
  { id: 'NRR', name: 'NRR' },
  { id: 'Pinnacle', name: 'Pinnacle' },
  { id: 'Prostar', name: 'Prostar' },
  { id: 'RH Series', name: 'RH Series' },
  { id: 'Silverado 4500HD', name: 'Silverado 4500HD' },
  { id: 'Silverado 5500HD', name: 'Silverado 5500HD' },
  { id: 'Silverado 6500HD', name: 'Silverado 6500HD' },
  { id: 'T180 / T280', name: 'T180 / T280' },
  { id: 'T380 / T480', name: 'T380 / T480' },
  { id: 'T680', name: 'T680' },
  { id: 'T680 Next Gen', name: 'T680 Next Gen' },
  { id: 'T680E', name: 'T680E' },
  { id: 'T800', name: 'T800' },
  { id: 'T880', name: 'T880' },
  { id: 'TerraPro', name: 'TerraPro' },
  { id: 'Transtar', name: 'Transtar' },
  { id: 'VAH', name: 'VAH' },
  { id: 'VHD', name: 'VHD' },
  { id: 'VNL', name: 'VNL' },
  { id: 'VNR Electric', name: 'VNR Electric' },
  { id: 'VNR Electric', name: 'VNR Electric' },
  { id: 'VNX', name: 'VNX' },
  { id: 'W900L', name: 'W900L' },
  { id: 'W990', name: 'W990' },
  { id: 'Workstar', name: 'Workstar' },
  { id: 'XL7', name: 'XL7' },
  { id: 'XL8', name: 'XL8' },
  { id: 'Other', name: 'Other' },
];

export const heavyDutyEngineMakes = [
  { id: 'Caterpillar', name: 'Caterpillar' },
  { id: 'Cummins', name: 'Cummins' },
  { id: 'Daimler', name: 'Daimler' },
  { id: 'Detroit Diesel', name: 'Detroit Diesel' },
  { id: 'Duramax', name: 'Duramax' },
  { id: 'Hino', name: 'Hino' },
  { id: 'Mercedes-Benz', name: 'Mercedes-Benz' },
  { id: 'Navistar', name: 'Navistar' },
  { id: 'PACCAR', name: 'PACCAR' },
  { id: 'Powerstroke', name: 'Powerstroke' },
  { id: 'Volvo', name: 'Volvo' },
  { id: 'Other', name: 'Other' },
];

export const heavyDutyFuelTypes = [
  { id: 'Diesel', name: 'Diesel' },
  { id: 'Gas', name: 'Gas' },
  { id: 'Natural Gas', name: 'Natural Gas' },
  { id: 'Other', name: 'Other' },
  { id: 'I Don’t Know', name: 'I Don’t Know' },
];

export const nonautomobileTabs = ['rv', 'atv', 'motorcycle', 'boat', 'plane'];

export const vehicleTypeTabLabels = {
  heavy: 'Heavy Duty',
  // license: 'License Plate',
  year: 'Year, Make, Model, Trim',
  // vin: 'VIN',
  boat: 'Boat',
  atv: 'ATV',
  rv: 'RV',
  motorcycle: 'Motorcycle',
  plane: 'Plane',
};

export const getVehicleType = (vehicle) => {
  if (!vehicle) return null;
  const vehicleTypeLabels = {
    heavy: 'Heavy Duty',
    license: 'Automobile',
    year: 'Automobile',
    vin: 'Automobile',
    boat: 'Boat',
    atv: 'ATV',
    rv: 'RV',
    motorcycle: 'Motorcycle',
    plane: 'Plane',
  };

  const inputMethodType = vehicle.input_method_type || vehicle.inputMethodType;
  return vehicleTypeLabels[inputMethodType] || '';
};

export const shouldDisplayVehicleType = () => {
  const {
    available_vehicle_entry_tabs: availableVehicleEntryTabs,
  } = getZ3PConfigValue();

  const automobileTabs = ['vin', 'license', 'year'];
  const automobileOnly = availableVehicleEntryTabs.every((tab) =>
    automobileTabs.includes(tab),
  );
  return !(availableVehicleEntryTabs.length < 2 || automobileOnly);
};
